new MutationObserver(() => {
    addEmptyAltToImagesWithoutAlt();
}).observe(document.body, { childList: true, subtree: true });

const addEmptyAltToImagesWithoutAlt = () => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

addEmptyAltToImagesWithoutAlt();
